import React from 'react';
import { Box, Icon } from '@chakra-ui/react';
import { FaBell } from 'react-icons/fa';

interface NotificationBellProps {
  notificationCount: number;
}

const NotificationBell: React.FC<NotificationBellProps> = ({ notificationCount }) => {
  const hasNotifications = notificationCount > 0;
  
  // Format the count: 1-9 shows as is, 10+ shows as "9+"
  const displayCount = notificationCount > 9 ? '9+' : notificationCount.toString();
  
  return (
    <Box position="relative" mt={1}>
      <Icon
        as={FaBell}
        color={hasNotifications ? 'white' : 'gray.500'}
        w={6}
        h={6}
        transition="color 0.2s"
      />
      {hasNotifications && (
        <Box
          position="absolute"
          top="-2"
          right="-2"
          bg="red.500"
          color="white"
          borderRadius="full"
          minW="18px"
          h="18px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          fontSize="xs"
          fontWeight="bold"
          border="2px solid"
          borderColor="rgba(0, 0, 0, 0.7)"
          boxShadow="0 2px 4px rgba(0, 0, 0, 0.3)"
        >
          {displayCount}
        </Box>
      )}
    </Box>
  );
};

export default NotificationBell; 